/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Businessprofileincompleteerror3Inputs */

const en_businessprofileincompleteerror3 = /** @type {(inputs: Businessprofileincompleteerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please complete your business profile first.`)
};

const de_businessprofileincompleteerror3 = /** @type {(inputs: Businessprofileincompleteerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vervollständige zuerst dein Unternehmensprofil.`)
};

/**
* | output |
* | --- |
* | "Please complete your business profile first." |
*
* @param {Businessprofileincompleteerror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const businessprofileincompleteerror3 = /** @type {((inputs?: Businessprofileincompleteerror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Businessprofileincompleteerror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_businessprofileincompleteerror3(inputs)
	return de_businessprofileincompleteerror3(inputs)
});
export { businessprofileincompleteerror3 as "businessProfileIncompleteError" }